import { makeStyles } from "@material-ui/core/styles";
export default makeStyles((theme) => ({
  hasResultContainer: { marginTop: 20 },
  noResultContainer: { marginTop: 20, textAlign: "center" },
}));
